import {AxiosError} from 'axios'
import React from 'react'

type ErrorTypes = AxiosError | Error

type HttpErrorHandler = (err: ErrorTypes) => void

const HttpErrorHandlerContext = React.createContext<HttpErrorHandler | undefined>(undefined)

export type HttpErrorHandlingComponentProps = {
  error: ErrorTypes | undefined
}

export function withHttpErrorHandler<TProps>(
  Component: React.ComponentType<TProps & HttpErrorHandlingComponentProps>
) {
  return class HttpErrorWrapper extends React.Component<
    Omit<TProps, 'error'>,
    {error: ErrorTypes | undefined}
  > {
    private readonly errorHandler: HttpErrorHandler

    constructor(props: Omit<TProps, 'error'>) {
      super(props)
      this.state = {error: undefined}
      this.errorHandler = (error: ErrorTypes) => {
        this.setState({error})
      }
    }

    render() {
      return (
        <HttpErrorHandlerContext.Provider value={this.errorHandler}>
          <Component {...(this.props as TProps)} error={this.state.error} />
        </HttpErrorHandlerContext.Provider>
      )
    }
  }
}
